module.exports = __webpack_public_path__ + "static/img/Shaun-Johnson.99e62c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Shaun-Johnson.jpg
// module id = vysS
// module chunks = 0